import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/browser';
import { SentryDSN } from 'shared/sentry.io';
import Vue from 'vue';

export function SentryForVue(oVue, initConfig = {}) {
    if (
        window.__SENTRY_IO_CONFIG &&
        window.__SENTRY_IO_CONFIG.hasOwnProperty('FEATURE_FLAG') &&
        window.__SENTRY_IO_CONFIG.FEATURE_FLAG &&
        window.__SENTRY_IO_CONFIG.hasOwnProperty('VUE_ENABLED') &&
        window.__SENTRY_IO_CONFIG.VUE_ENABLED
    ) {
        const config = Object.assign(
            {
                Vue,
                attachProps: true,
                logErrors: window.__SENTRY_IO_CONFIG.VUE_LOG_ERRORS ?? false,
                dsn: SentryDSN.vue,
                release: window.__SENTRY_IO_CONFIG.BUILD_NUMBER ?? '',
                environment: window.location.hostname,
                integrations: [new Integrations.BrowserTracing()],
                tracesSampleRate: 0.1,
            },
            initConfig,
        );

        new Sentry.init(config);
    }
}
